import { BundleComponent } from "@tm/morpheus"
import component from "./component"

const ExternalOffers: BundleComponent = {
    name: "external-catalogs-iframe",
    component,
}

export default ExternalOffers
